var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("任务管理")]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("任务实做人员明细")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageSerch" },
          [
            _c(
              "el-card",
              { staticClass: "box-card", attrs: { shadow: "never" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "cardTitle" }, [
                      _vm._v("任务实做人员明细"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  { ref: "ruleForm", attrs: { model: _vm.ruleForm } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 24 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "50",
                                    clearable: "",
                                    placeholder: "请输入保安姓名",
                                  },
                                  model: {
                                    value: _vm.ruleForm.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "name", $$v)
                                    },
                                    expression: "ruleForm.name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "50",
                                    clearable: "",
                                    placeholder: "请输入保安手机号",
                                  },
                                  model: {
                                    value: _vm.ruleForm.phone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "phone", $$v)
                                    },
                                    expression: "ruleForm.phone",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "状态" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { "margin-right": "auto" },
                                    attrs: { placeholder: "请选择工作状态" },
                                    model: {
                                      value: _vm.ruleForm.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm, "status", $$v)
                                      },
                                      expression: "ruleForm.status",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "未开始", value: "1" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "工作中", value: "2" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "已完成", value: "3" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "已结算", value: "4" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: { label: "已取消", value: "5" },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: "已开除(未结算)",
                                        value: "6",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: "已开除(已结算)",
                                        value: "7",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: "已取消已结算",
                                        value: "8",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 4 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getList()
                                      },
                                    },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetForm()
                                      },
                                    },
                                  },
                                  [_vm._v("重置")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTab" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.exportList(1)
                  },
                },
              },
              [_vm._v("实做保安明细导出")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.exportList()
                  },
                },
              },
              [_vm._v("实做保安考勤明细导出")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "pageInfo" }, [
              _c("div", { staticStyle: { "margin-top": "10px" } }, [
                _vm._v("任务名称：" + _vm._s(_vm.pageData.title)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dis" }, [
                _c("div", [
                  _vm._v(
                    "任务需求人数：" + _vm._s(_vm.pageData.membersNum) + "人"
                  ),
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("身高：" + _vm._s(_vm.pageData.highName))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dis" }, [
                _c("div", [
                  _vm._v("任务单价：" + _vm._s(_vm.pageData.unitPrice)),
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("年龄：" + _vm._s(_vm.pageData.ageTypeName)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dis" }, [
                _c("div", [
                  _vm._v("服务时长：" + _vm._s(_vm.pageData.serviceTimeStr)),
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("着装：" + _vm._s(_vm.pageData.dressTypeName)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { "margin-top": "10px" } }, [
                _vm._v(
                  "\n          任务开始/结束时间：" +
                    _vm._s(_vm.pageData.jobStart) +
                    "-" +
                    _vm._s(_vm.pageData.jobEnd) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { "margin-top": "10px" } }, [
                _vm._v("任务地址：" + _vm._s(_vm.pageData.address)),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%", "margin-top": "20px" },
                attrs: { data: _vm.tableData, "tooltip-effect": "dark" },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "jobNo",
                    label: "任务编号",
                    align: "center",
                    width: "200",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "任务名称", align: "center", width: "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-popover",
                            { attrs: { trigger: "hover", placement: "top" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(scope.row.title) +
                                  "\n              "
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "name-wrapper",
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  _c("div", { staticClass: "omit" }, [
                                    _vm._v(_vm._s(scope.row.title)),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "bodyguardName",
                    label: "保安姓名",
                    align: "center",
                    width: "180",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "实际服务时长",
                    align: "center",
                    width: "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.workedTimeStr) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "补偿服务时长",
                    align: "center",
                    width: "190",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(_vm._s(scope.row.extraSettledMinutesStr)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "预期收益", align: "center", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              "￥" +
                                _vm._s(
                                  _vm._f("moneyFormat")(
                                    scope.row.expectedIncome
                                  )
                                )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "实际收益", align: "center", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              "￥" +
                                _vm._s(
                                  _vm._f("moneyFormat")(
                                    scope.row.actualSecIncome
                                  )
                                )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "服务扣款", align: "center", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              "￥" +
                                _vm._s(
                                  _vm._f("moneyFormat")(scope.row.deduction)
                                )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "状态", align: "center", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", { staticClass: "blueColor" }, [
                            _vm._v(_vm._s(scope.row.workStatusName)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "操作",
                    align: "center",
                    fixed: "right",
                    width: "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "disAround" }, [
                            _c(
                              "div",
                              {
                                staticClass: "operateBtn",
                                on: {
                                  click: function ($event) {
                                    return _vm.goDetail1(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                查看考勤\n              "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                "page-sizes": [10, 20, 30, 50],
                "page-size": _vm.pageSize,
                layout: "total, prev, pager, next,sizes",
                total: _vm.total,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handleCurrentChange,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }